/* eslint-disable no-console */
import {MoreOutlined} from '@ant-design/icons';
import {Divider, Popconfirm, Popover} from 'antd';
import React from 'react';

const PopoverMapData: React.FC<{
  setEditData: React.Dispatch<any>;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: (_id: string[] | string) => void;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
  setShowPopup: React.Dispatch<React.SetStateAction<boolean[]>>;
  items: any;
  index: number;
  showPopup: boolean[];
  blockDelete?: boolean;
}> = ({
  handleDelete,
  setEditData,
  setIsEdit,
  setShowModel,
  items,
  index,
  showPopup,
  setShowPopup,
  blockDelete = false
}) => {
  const handlePopoverToggle = (index: number) => {
    const newShowPopups = [...showPopup];
    newShowPopups[index] = !newShowPopups[index];
    setShowPopup(newShowPopups);
  };

  return (
    <div>
      <Popover
        open={showPopup[index]}
        onOpenChange={() => {
          handlePopoverToggle(index);
        }}
        placement="rightTop"
        arrow={{pointAtCenter: true}}
        content={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '5rem',
              alignItems: 'flex-start'
            }}
          >
            <div
              style={{
                border: 'none',
                cursor: 'pointer',
                font: 'normal normal 400 14px/22px Montserrat',
                letterSpacing: '0px',
                color: '#000000',
                opacity: 1
              }}
              onClick={() => {
                setShowModel(true);
                setEditData(items);
                setIsEdit(true);
                handlePopoverToggle(index);
              }}
            >
              Edit
            </div>

            {blockDelete ? null : (
              <>
                <Divider
                  style={{
                    margin: '12px -12px 12px -12px',
                    width: '130%',
                    borderColor: '#D9D9D9'
                  }}
                />
                <Popconfirm
                  title="Sure to delete?"
                  style={{
                    border: 'none',
                    font: 'normal normal 400 14px/22px Montserrat',
                    letterSpacing: '0px',
                    color: '#000000',
                    opacity: 1
                  }}
                  onConfirm={() => {
                    handleDelete([items._id]);
                    handlePopoverToggle(index);
                  }}
                >
                  <div style={{cursor: 'pointer'}}>Delete</div>
                </Popconfirm>
              </>
            )}
          </div>
        }
        trigger="click"
        overlayInnerStyle={{
          inset: '355px auto auto 565px'
        }}
      >
        <MoreOutlined
          style={{
            color: 'rgba(220, 220, 220, 1)',
            fontSize: '21px',
            strokeWidth: '80',
            stroke: 'rgba(220, 220, 220, 1)'
          }}
        />
      </Popover>
    </div>
  );
};

export default PopoverMapData;
